"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SentimentAnalyzerServiceServer = exports.SentimentAnalyzerServiceDispatcher = exports.SentimentAnalyzerServiceClient = void 0;
var octopus_common_1 = require("@playq/octopus-common");
var services_shared_1 = require("@playq/services-shared");
var services_common_sentiments_1 = require("@playq/services-common-sentiments");
var irt_1 = require("@playq/irt");
var InQueryDataset = (function () {
    function InQueryDataset(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.iterator = new services_shared_1.OffsetLimit(data.iterator);
        this.sortBy = data.sortBy.map(function (e) { return new services_common_sentiments_1.DatasetSort(e); });
        this.filterBy = Object.keys(data.filterBy).reduce(function (previous, current) { previous[current] = octopus_common_1.FilterHelpers.deserialize(data.filterBy[current]); return previous; }, {});
    }
    Object.defineProperty(InQueryDataset.prototype, "iterator", {
        get: function () {
            return this._iterator;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field iterator is not optional');
            }
            this._iterator = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InQueryDataset.prototype, "sortBy", {
        get: function () {
            return this._sortBy;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field sortBy is not optional');
            }
            this._sortBy = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InQueryDataset.prototype, "filterBy", {
        get: function () {
            return this._filterBy;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field filterBy is not optional');
            }
            this._filterBy = value;
        },
        enumerable: false,
        configurable: true
    });
    InQueryDataset.prototype.serialize = function () {
        var _this = this;
        return {
            iterator: this.iterator.serialize(),
            sortBy: this.sortBy.map(function (e) { return e.serialize(); }),
            filterBy: Object.keys(this.filterBy).reduce(function (previous, current) { previous[current] = octopus_common_1.FilterHelpers.serialize(_this.filterBy[current]); return previous; }, {})
        };
    };
    return InQueryDataset;
}());
var OutQueryDatasetHelpers = (function () {
    function OutQueryDatasetHelpers() {
    }
    OutQueryDatasetHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutQueryDatasetHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new services_common_sentiments_1.QueryDatasetResponse(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutQueryDatasetHelpers;
}());
var InUpdateDataEntry = (function () {
    function InUpdateDataEntry(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.entry = new services_common_sentiments_1.SentimentDataEntry(data.entry);
    }
    Object.defineProperty(InUpdateDataEntry.prototype, "entry", {
        get: function () {
            return this._entry;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field entry is not optional');
            }
            this._entry = value;
        },
        enumerable: false,
        configurable: true
    });
    InUpdateDataEntry.prototype.serialize = function () {
        return {
            entry: this.entry.serialize()
        };
    };
    return InUpdateDataEntry;
}());
var OutUpdateDataEntryHelpers = (function () {
    function OutUpdateDataEntryHelpers() {
    }
    OutUpdateDataEntryHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutUpdateDataEntryHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new services_shared_1.CommonSuccess(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutUpdateDataEntryHelpers;
}());
var InCreateDataEntry = (function () {
    function InCreateDataEntry(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.sentence = new services_common_sentiments_1.LabeledSentence(data.sentence);
        this.model = services_common_sentiments_1.SentimentModel[data.model];
    }
    Object.defineProperty(InCreateDataEntry.prototype, "sentence", {
        get: function () {
            return this._sentence;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field sentence is not optional');
            }
            this._sentence = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InCreateDataEntry.prototype, "model", {
        get: function () {
            return this._model;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field model is not optional');
            }
            this._model = value;
        },
        enumerable: false,
        configurable: true
    });
    InCreateDataEntry.prototype.serialize = function () {
        return {
            sentence: this.sentence.serialize(),
            model: services_common_sentiments_1.SentimentModel[this.model]
        };
    };
    return InCreateDataEntry;
}());
var OutCreateDataEntryHelpers = (function () {
    function OutCreateDataEntryHelpers() {
    }
    OutCreateDataEntryHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutCreateDataEntryHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new services_common_sentiments_1.SentimentDataEntry(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutCreateDataEntryHelpers;
}());
var InTrainModel = (function () {
    function InTrainModel(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.model = services_common_sentiments_1.SentimentModel[data.model];
    }
    Object.defineProperty(InTrainModel.prototype, "model", {
        get: function () {
            return this._model;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field model is not optional');
            }
            this._model = value;
        },
        enumerable: false,
        configurable: true
    });
    InTrainModel.prototype.serialize = function () {
        return {
            model: services_common_sentiments_1.SentimentModel[this.model]
        };
    };
    return InTrainModel;
}());
var OutTrainModelHelpers = (function () {
    function OutTrainModelHelpers() {
    }
    OutTrainModelHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutTrainModelHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new services_shared_1.CommonSuccess(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutTrainModelHelpers;
}());
var SentimentAnalyzerServiceClient = (function () {
    function SentimentAnalyzerServiceClient(transport) {
        this._transport = transport;
    }
    SentimentAnalyzerServiceClient.prototype.getPackageName = function () { return SentimentAnalyzerServiceClient.PackageName; };
    SentimentAnalyzerServiceClient.prototype.getClassName = function () { return SentimentAnalyzerServiceClient.ClassName; };
    SentimentAnalyzerServiceClient.prototype.getFullClassName = function () { return SentimentAnalyzerServiceClient.FullClassName; };
    SentimentAnalyzerServiceClient.prototype.send = function (method, data, inputType, outputType) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this._transport.send(SentimentAnalyzerServiceClient.ClassName, method, data)
                .then(function (data) {
                try {
                    var output = new outputType(data);
                    resolve(output);
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    SentimentAnalyzerServiceClient.prototype.queryDataset = function (iterator, sortBy, filterBy) {
        var _this = this;
        var __data = new InQueryDataset();
        __data.iterator = iterator;
        __data.sortBy = sortBy;
        __data.filterBy = filterBy;
        return new Promise(function (resolve, reject) {
            _this._transport.send(SentimentAnalyzerServiceClient.ClassName, 'queryDataset', __data)
                .then(function (data) {
                try {
                    resolve(OutQueryDatasetHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    SentimentAnalyzerServiceClient.prototype.updateDataEntry = function (entry) {
        var _this = this;
        var __data = new InUpdateDataEntry();
        __data.entry = entry;
        return new Promise(function (resolve, reject) {
            _this._transport.send(SentimentAnalyzerServiceClient.ClassName, 'updateDataEntry', __data)
                .then(function (data) {
                try {
                    resolve(OutUpdateDataEntryHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    SentimentAnalyzerServiceClient.prototype.createDataEntry = function (sentence, model) {
        var _this = this;
        var __data = new InCreateDataEntry();
        __data.sentence = sentence;
        __data.model = model;
        return new Promise(function (resolve, reject) {
            _this._transport.send(SentimentAnalyzerServiceClient.ClassName, 'createDataEntry', __data)
                .then(function (data) {
                try {
                    resolve(OutCreateDataEntryHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    SentimentAnalyzerServiceClient.prototype.trainModel = function (model) {
        var _this = this;
        var __data = new InTrainModel();
        __data.model = model;
        return new Promise(function (resolve, reject) {
            _this._transport.send(SentimentAnalyzerServiceClient.ClassName, 'trainModel', __data)
                .then(function (data) {
                try {
                    resolve(OutTrainModelHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    SentimentAnalyzerServiceClient.PackageName = 'net.playq.octopus2.markets';
    SentimentAnalyzerServiceClient.ClassName = 'SentimentAnalyzerService';
    SentimentAnalyzerServiceClient.FullClassName = 'net.playq.octopus2.markets.SentimentAnalyzerService';
    return SentimentAnalyzerServiceClient;
}());
exports.SentimentAnalyzerServiceClient = SentimentAnalyzerServiceClient;
var SentimentAnalyzerServiceDispatcher = (function () {
    function SentimentAnalyzerServiceDispatcher(marshaller, server) {
        this.marshaller = marshaller;
        this.server = server;
    }
    SentimentAnalyzerServiceDispatcher.prototype.getSupportedService = function () {
        return 'SentimentAnalyzerService';
    };
    SentimentAnalyzerServiceDispatcher.prototype.getSupportedMethods = function () {
        return SentimentAnalyzerServiceDispatcher.methods;
    };
    SentimentAnalyzerServiceDispatcher.prototype.dispatch = function (context, method, data) {
        var _this = this;
        switch (method) {
            case "queryDataset": {
                var obj_1 = new InQueryDataset(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.queryDataset(context, obj_1.iterator, obj_1.sortBy, obj_1.filterBy)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutQueryDatasetHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "updateDataEntry": {
                var obj_2 = new InUpdateDataEntry(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.updateDataEntry(context, obj_2.entry)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutUpdateDataEntryHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "createDataEntry": {
                var obj_3 = new InCreateDataEntry(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.createDataEntry(context, obj_3.sentence, obj_3.model)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutCreateDataEntryHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "trainModel": {
                var obj_4 = new InTrainModel(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.trainModel(context, obj_4.model)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutTrainModelHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            default:
                throw new Error("Method ".concat(method, " is not supported by SentimentAnalyzerServiceDispatcher."));
        }
    };
    SentimentAnalyzerServiceDispatcher.methods = [
        "queryDataset",
        "updateDataEntry",
        "createDataEntry",
        "trainModel"
    ];
    return SentimentAnalyzerServiceDispatcher;
}());
exports.SentimentAnalyzerServiceDispatcher = SentimentAnalyzerServiceDispatcher;
var SentimentAnalyzerServiceServer = (function (_super) {
    __extends(SentimentAnalyzerServiceServer, _super);
    function SentimentAnalyzerServiceServer(marshaller) {
        var _this = _super.call(this, marshaller, null) || this;
        _this.server = _this;
        return _this;
    }
    SentimentAnalyzerServiceServer.prototype.queryDataset = function (context, iterator, sortBy, filterBy) {
        throw new Error('Not implemented.');
    };
    SentimentAnalyzerServiceServer.prototype.updateDataEntry = function (context, entry) {
        throw new Error('Not implemented.');
    };
    SentimentAnalyzerServiceServer.prototype.createDataEntry = function (context, sentence, model) {
        throw new Error('Not implemented.');
    };
    SentimentAnalyzerServiceServer.prototype.trainModel = function (context, model) {
        throw new Error('Not implemented.');
    };
    return SentimentAnalyzerServiceServer;
}(SentimentAnalyzerServiceDispatcher));
exports.SentimentAnalyzerServiceServer = SentimentAnalyzerServiceServer;
//# sourceMappingURL=SentimentAnalyzerService.js.map